import { useParentEl } from "@/hooks/common/useParentEl";
// import { renderAllCsrCmp } from '@/utils/csrCmpSet';
import { getCsrCmpItemState } from '@/store/state';
import { getStore } from "@/store/index";
import { __CLASS_CSR_CMP__, __CLASS_FORM_PANEL__, __CLASS_FORM_PANEL_GROUP__, __CLASS_FORM_ITEM__ } from "@/const/ssrClass";
import { __FIELD_TYPE_DATE__ } from "@/const/fieldType";
import { useDestoryCsrVm } from "@/hooks/common/useCsrVm";
import { v4 as uuidv4 } from 'uuid';

export default {
    // panel中点击添加
    handleClickAdd(target) {
        const panel = useParentEl(target, __CLASS_FORM_PANEL__);
        const firstGroup = panel.querySelector(`.${__CLASS_FORM_PANEL_GROUP__}`); // 第一个group
        const newGroup = document.createElement('div'); // 新增的group
        newGroup.className = __CLASS_FORM_PANEL_GROUP__;
        // 复制第一个group
        newGroup.innerHTML = firstGroup.innerHTML;
        newGroup.querySelectorAll(`.${__CLASS_CSR_CMP__}`).forEach(el => {
            // 重置vue初始化容器
            el.innerHTML = '<div class="csr-cmp__content"></div>';
            // 重置id
            el.id = `${el.dataset.cmp}-${uuidv4()}`;
            // 在store中添加state
            const store = getStore();
            const state = getCsrCmpItemState(el);
            store.addCsrState(el.id, state);

        });
        // 将复制完成的dom插入视图
        panel.querySelector('.form-panel__group-container').append(newGroup);
        window?.renderAllCsrCmp?.();// 分了品牌之后，这些方法都没办法export了，所以需要调用window上的
    },
    // panel中点击删除
    handleClickDel(target) {
        const currentGroup = useParentEl(target, __CLASS_FORM_PANEL_GROUP__);
        currentGroup.querySelectorAll(`.${__CLASS_CSR_CMP__}`).forEach(el => {
            // 卸载实例
            useDestoryCsrVm(el.id);
        });
        // 3.删除dom
        const panel = $(currentGroup).closest('.form-panel');
        currentGroup.remove();

        // 4.重绘计数器
        if (panel.length) {
            panel.addClass('no-counter');
            requestAnimationFrame(() => {
                panel.removeClass('no-counter');
            });
        }
    },
    // form item的点击事件，给item加上对应的属性，实现label mask的效果
    // eslint-disable-next-line
    handleClickFormItem(target) {
        const csrCmp = useParentEl(target, __CLASS_CSR_CMP__);
        const formItem = useParentEl(target, __CLASS_FORM_ITEM__);
        // 如果是date类型，则不走此逻辑，因为date类型的日期下拉渲染在body上，比较难判断，所以采用组件的focus和blur事件
        if (formItem?.getAttribute("fieldtype") === __FIELD_TYPE_DATE__) {
            return;
        };
        // 如果点击的是form item，则加上focus属性，这里之所以不用class，是因为form item上有一个动态的class，这会导致校验时会把通过js加上的class覆盖
        const store = getStore();
        if (!store || !store.csrState) { return; }
        for (const itemKey in store.csrState) {
            if (Object.prototype.hasOwnProperty.call(store.csrState, itemKey)) { // Add this line
                const csrCmpItem = document.querySelector(`[id='${itemKey}']`);
                if (formItem && csrCmpItem?.id === csrCmp?.id) {
                    formItem.setAttribute("data-focus", true);
                } else if (!store.csrState[itemKey].value) {
                    // 如果点击在别的区域，且没有选值，则去掉focus类，如果选了值，则保持
                    const item = csrCmpItem?.querySelector("." + __CLASS_FORM_ITEM__) ?? "";
                    item && item.removeAttribute("data-focus");
                }
            }
        }
    },
    // 初始化状态
    initFocusState() {
        const store = getStore();
        if (!store || !store.csrState) { return; }
        for (const itemKey in store.csrState) {
            if (store.csrState[itemKey].value) {
                const item = document.querySelector(`[id='${itemKey}'] .${__CLASS_FORM_ITEM__}`);
                item && item.setAttribute("data-focus", true);
            }
        }
    },
    init() {
        document.addEventListener(
            "click",
            (e) => {
                const { target } = e;
                // 解决svg 节点无classname的问题
                if (target.nodeName !== 'svg') {
                    if (target?.parentNode?.className?.includes('form-panel__operate-add') ||
                        target?.className?.includes("form-panel__operate-add")) {
                        this.handleClickAdd(target);
                    }
                    if (target?.className?.includes("form-panel__group-del")) {
                        this.handleClickDel(target);
                    }

                    // form item点击事件
                    this.handleClickFormItem(target);
                }
                // 新增：判断target的className是否等于"md-select-dropdown md-popper"
                if (target.className === "md-select-dropdown md-popper") {
                   const select = $(target).closest(".md-select")
                   const hasEcommerceClass = select.parents(".form-v3-ecommerce")?.length
                   if(hasEcommerceClass){
                       select.click()
                   }
                }
            },
            true
        );
        // 初始化一下状态，对于有默认值的，展示为focus状态
        this.initFocusState();
    },
};
